import { ColorEnum } from '@/constants/color'
import { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const TriangleIcon: FC<SvgProps> = (props) => {
    return (
        <Svg fill={ColorEnum.GRAY_100} height={10} width={24} {...props}>
            <Path d="M9.44 1.134a4 4 0 0 1 5.12 0L24 9H0l9.44-7.866Z" />
        </Svg>
    )
}

export default TriangleIcon
